export default {
  getVueAppVersion: state => state.packageVersion,
  getDbReady: state => state.dbReady,
  //
  // ----- Global Permissions
  //
  getTrackingAllowed: state => state.trackingAllowed,
  getSensorsAllowed: state => state.sensorsAllowed,
  //
  // ----- Browser API permissions
  //
  getGeolocationPermissionStatus: state => state.geolocationPermissionStatus,
  getGysroscopePermissionStatus: state => state.gyroscopePermissionStatus,
  //
  // ----- Geolocation settings
  //
  getEnableHighAccuracy: state => state.enableHighAccuracy,
  getMaximumAge: state => state.maximumAge,
  getTimeout: state => state.timeout,
  //
  getGeolocationSettings: (state, getters) => {
    return {
      enableHighAccuracy: getters.getEnableHighAccuracy,
      maximumAge: getters.getMaximumAge,
      timeout: getters.getTimeout
    }
  },
  //
  // ----- Geolocation Recording constrains
  //
  getUseMinSpeedThreshold: state => state.useMinSpeedThreshold,
  getMinSpeedThreshold: state => state.minSpeedThreshold,
  getUseRecordingTimeInterval: state => state.useRecordingTimeInterval,
  getRecordingTimeInterval: state => state.recordingTimeInterval,
  //
  // Reverse Geocoding
  //
  getAddressService: state => state.addressService,
  //
  // ----- Notification when not moving
  //
  getShowNotificationWhenNotMoving: state => state.showNotificationWhenNotMoving,
  //
  // ----- Zoom
  //
  getZoomLevelNear: state => state.zoomLevelNear,
  getZoomLevelFar: state => state.zoomLevelFar,
  getZoomLevelManual: state => state.zoomLevelManual,
  getZoomLevelCurrent: state => {
    return state.zoomLevelManual === undefined
      ? state.zoomLevelFar
      : state.zoomLevelManual
  },
  //
  // ----- Pagination: Max items per page
  //
  getMaxMapHostsPerPage: state => state.maxMapHostsPerPage,
  getMaxNotesPerPage: state => state.maxNotesPerPage,
  getMaxTrackedRoutesPerPage: state => state.maxTrackedRoutesPerPage,
  //
  // ----- Device settings
  //
  getScreenWakeLockAvailability: state => state.screenWakeLockAvailability,
  //
  // ------ Sensores
  //
  getUsePedometer: state => state.usePedometer,
  //
  // ----- Console, debugging and Log txt
  //
  getConsole: state => state.console,
  getDebugging: state => state.debugging,
  getLog: state => state.log,
  //
  // Needs more attention
  getSaveAccidentallyInterruptedRecording: state => state.saveAccidentallyInterruptedRecording
}
